module.exports = __webpack_public_path__ + "img/p2.ed9620d0.png";